import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMusic, FiCpu } = FiIcons;

const Header = () => {
  return (
    <header className="text-center mb-12">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex items-center justify-center gap-3 mb-4"
      >
        <div className="relative">
          <SafeIcon icon={FiMusic} className="text-4xl text-orange-600" />
          <SafeIcon 
            icon={FiCpu} 
            className="text-xl text-amber-500 absolute -bottom-1 -right-1 bg-orange-50 rounded-full p-0.5" 
          />
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold text-stone-800 tracking-tight">
          Suno<span className="text-orange-600">Sync</span>
        </h1>
      </motion.div>
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="text-stone-600 text-lg max-w-2xl mx-auto"
      >
        Analyze any YouTube song and instantly generate 10 tailored, high-quality prompts optimized for Suno V5 generation.
      </motion.p>
    </header>
  );
};

export default Header;